import * as Device from 'expo-device';
import { Platform } from 'react-native';

export const isLimitedDevice = () =>
  Platform.OS === 'android' && Device.totalMemory
    ? Device.totalMemory < 4 * 1024 * 1024 * 1024 // 4 GB
    : false;
